<template>
  <div class="absolute inset-0 top-20">
    <div class="h-full">
      <risque-diagram
        :positioned="positionedData"
        :datas="datas"
        ref="diagram"
        @makereport="_makeReport"
      />
    </div>
  </div>
  <help :info="info" />
</template>

<script>
import globalMixins from "@/utils/mixins/mixin.js";
import Help from "@/components/Help.vue";
import RisqueDiagram from "@/components/AR/RisqueDiagram.vue";

export default {
  mixins: [globalMixins],
  components: { Help, RisqueDiagram },
  methods: {
    async _makeReport() {
      this.generating = true;
      this.$swal.fire("Edition du rapport");
      this.$swal.showLoading();

      var pdfData = {
        module: this.currentModule,
        folder: this.currentFolder,
        file: this.currentFile,
        actors: window._.sortBy(this.datas, "name"),
        actorLabel: "Risque",
        actorKey: "name",
        identificationLabel: ["Risque"],
        identificationKey: ["name"],
        titles: [
          "Identification des risques à intégrer dans l’axe d’analyse de la problématique traitée",
          "Evaluation des risques en fonction de leurs probabilités de survenance et de leurs impacts",
          "Visualisation de la matrice de l’analyse des risques",
        ],
        categoriesLabel: ["Risque", "Fréquence", "Impact"],
        categoriesKey: ["probability", "gravity"],
        images: [
          /* { data: "", legend: "", title: "" } */
        ],
      };
      var im1 = await this.$refs.diagram.downloadImage();

      pdfData.images.push(im1);
      console.log(pdfData);
      this.$swal.hideLoading();

      this.$toast.fire({ title: "Le rapport a été edité", icon: "success" });
      this.makeReport(pdfData);
    },
  },
  computed: {
    info() {
      return {
        name: this.currentModule?.name,
        description: this.currentModule?.moduleDescription,
      };
    },
  },
  data() {
    return {
      editionActive: false,
      eltKey: 0,
      folders: null,
      probabilityList: [
        { id: 1, value: "Hypothetique" },
        { id: 2, value: "Exceptionnel" },
        { id: 3, value: "Aleatoire" },
        { id: 4, value: "Probable" },
        { id: 5, value: "Chronique" },
        { id: 6, value: "Permanent" },
      ], // facilité de mise en oeuvre
      gravityList: [
        { id: 1, value: "Mineur" },
        { id: 2, value: "Mineur" },
        { id: 3, value: "Modéré" },
        { id: 4, value: "Majeur" },
        { id: 5, value: "Intense" },
        { id: 6, value: "Critique" },
      ], // importance

      newElt: {
        id: "",
        value: "",
        importance: undefined,
        meo: undefined,
      },
      editedElt: {
        id: "",
        value: "",
        importance: undefined,
        meo: undefined,
      },
      positionedData: [[], [], [], [], [], []],
      colors: {
        lightYellow: "#ebcb8d",
        lightBlue: "#5B9BD5",
        strongYellow: "#fcba03",
        lightGreen: "#57997a",
        strongGreen: "#0f631e",
        lightRed: "#c44d57",
        gray: "gray",
        white: "#fff",
        black: "#111",
      },

      dim: null, // Dimensions du conteneur du dessin
      ctx: null, // Contexte canvas
      size: null, // taille de la zone de dessin
      small: null, // Attribut small
      interval: null, // Interval entre les intersections
      rayon: null, // Rayon des activités
      maxNbrArray: [], // Nbre max d'activité pour les collisions
      maxNbr: 1, // Valeur max par défaut
      lightLine: 5, // Epaisseur d'une ligne mince
    };
  },

  async mounted() {
    this.folders =
      localStorage.getItem("temp-folder") !== null
        ? JSON.parse(localStorage.getItem("temp-folder"))
        : [];

    if (this.currentFile === null) this.datas = [];
    else {
      /* this.datas =
        localStorage.getItem(
          "temp-analyse-risques-" + this.currentFile.name
        ) !== null
          ? JSON.parse(
              localStorage.getItem(
                "temp-analyse-risques-" + this.currentFile.name
              )
            )
          : []; */
    }

    var response = await this.$axios.get(
      "/RiskPriorisationsQueries/GetRiskPriorisationAnalysis/" +
        this.currentFile.fileID
    );
    this.datas = response.data.map((x) => {
      var data = {
        ...x,
        name: x.riskName,
        gravity: { ...this.gravityList.find((y) => x.gravity == y.id) },
        probability: {
          ...this.probabilityList.find((y) => x.probability == y.id),
        },
      };
      this.positionedData[x.probability - 1][x.gravity - 1] = [
        data,
        ...(this.positionedData[x.probability - 1][x.gravity - 1] ?? []),
      ];
      return data;
    });
  },
};
</script>
